import {
	IModel,
	IVIPContactBase,
	VIPContactBase,
} from "@/loader";

/**
 * Contact Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export interface IVIPContact extends IVIPContactBase {
}

/**
 * Contact Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export class VIPContact extends VIPContactBase implements IVIPContact, IModel<IVIPContact> {
	constructor (data: IVIPContact = {}) {
		super(data);
	}

	public load(data: IVIPContact) {
		super.load(data);
	}

	public update(data: IVIPContact) {
		super.update(data);
	}

	public get fullName(): string {
		return [this.getCivilityLabel(), this.first_name, this.last_name].filter(x => !!x).join(" ");
	}

	public get phoneLink(): string {
		return this.phone ? "tel:" + this.phone.replace(/[\s\.+-]|\(.*\)/g, "") : "";
	}

	public get emailLink(): string {
		return this.email ? "mailto:" + this.email : "";
	}

	public toString(): string {
		return [this.getCivilityLabel(), this.first_name, this.last_name].filter(x => !!x).join(" ");
	}

	public toStringNoCiv(): string {
		return [this.first_name, this.last_name].filter(x => !!x).join(" ");
	}
}
